module.exports = __webpack_public_path__ + "images/pro/pro-logo-huge@2x-5d240cd7b87746036b45a8826b66c571.png";